import { render } from "./AppSidebarItem.vue?vue&type=template&id=39c91ff9&scoped=true"
import script from "./AppSidebarItem.vue?vue&type=script&lang=js"
export * from "./AppSidebarItem.vue?vue&type=script&lang=js"

import "./AppSidebarItem.vue?vue&type=style&index=0&id=39c91ff9&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c91ff9"]])

export default __exports__